export const homeTranslations = {
    en: {
        tagline: 'Find your person with intention',
        heroTitle: 'Tailored introductions for serious commitments',
        heroDescription: 'We guide you with warmth, clarity, and privacy-first conversations that help you connect deeply and intentionally.',
        galleryHeading: 'Community gallery',
        galleryBadge: 'Moments',
        clarityKicker: 'Clarity & Care',
        clarityTitle: 'Why couples choose Perfect Timing',
        clarityBadge: 'Serious, thoughtful, human',
        journeyKicker: 'Guided journey',
        journeyTitle: 'How we help you move forward',
        journeyCta: 'Chat with our team',
        supportKicker: 'Support that stays with you',
        supportTitle: 'We keep things organised so you can focus on connection',
        supportDescription: 'Choose what you need right now—learn, review experiences, or start your application.',
        readyKicker: 'Ready to begin?',
        readyTitle: 'Take the next step today',
        introGreeting: 'Marhaba',
        signup: 'SIGN UP',
        talkToUs: 'TALK TO US',
        login: 'LOGIN',
        goToProfile: 'GO TO PROFILE',
        howItWorks: 'HOW IT WORKS',
        reviews: 'REVIEWS',
        faqs: "FAQ'S",
        highlights: [
            {
                title: 'Intentional matchmaking',
                detail: 'Thoughtfully curated introductions that honour your values, culture, and timeline.',
            },
            {
                title: 'Privacy first',
                detail: 'Your story stays protected with discreet conversations and secure data handling.',
            },
            {
                title: 'Human support',
                detail: 'A dedicated team to guide you, answer questions, and cheer for your next chapter.',
            },
        ],
        steps: [
            {
                title: 'Share your goals',
                detail: 'Start with a quick signup and tell us what matters most to you.',
            },
            {
                title: 'Meet with intention',
                detail: 'We make introductions that align with your readiness for marriage.',
            },
            {
                title: 'Move forward confidently',
                detail: 'We stay close with check-ins, guidance, and resources along the way.',
            },
        ],
        supportDetails: [
            'Guided next steps when conversations are going well or need care.',
            'Balanced profiles to showcase sincerity without oversharing.',
            'Clear pathways to reach our team whenever you need support.',
        ],
    },
    sw: {
        tagline: 'Mpate mwenzi wako kwa makusudi',
        heroTitle: 'Utambulisho uliobinafsishwa kwa nia ya ndoa',
        heroDescription: 'Tunakusindikiza kwa upole, uwazi, na faragha ili ujenge mawasiliano ya kina na ya makini.',
        galleryHeading: 'Mkusanyiko wa jamii',
        galleryBadge: 'Matukio',
        clarityKicker: 'Uwazi na Uangalizi',
        clarityTitle: 'Kwa nini wanandoa huchagua Perfect Timing',
        clarityBadge: 'Mafundi, wangalifu, wa kibinadamu',
        journeyKicker: 'Safari inayoongozwa',
        journeyTitle: 'Jinsi tunavyokusaidia kusonga mbele',
        journeyCta: 'Zungumza na timu yetu',
        supportKicker: 'Msaada unaobaki nawe',
        supportTitle: 'Tunapanga mambo ili ubaki kwenye kuunganishwa',
        supportDescription: 'Chagua unachohitaji sasa—jifunze, soma uzoefu, au anza maombi yako.',
        readyKicker: 'Uko tayari kuanza?',
        readyTitle: 'Chukua hatua inayofuata leo',
        introGreeting: 'Marhaba',
        signup: 'JISAJILI',
        talkToUs: 'WASILIANE NASI',
        login: 'INGIA',
        goToProfile: 'NENDA KWENYE WASIFU',
        howItWorks: 'JINSI INAVYOFANYA KAZI',
        reviews: 'MAONI',
        faqs: 'MASWALI YA MARA KWA MARA',
        highlights: [
            {
                title: 'Ulinganishaji wa makusudi',
                detail: 'Utambulisho uliopangwa kwa makini unaoheshimu maadili, utamaduni, na muda wako.',
            },
            {
                title: 'Faragha kwanza',
                detail: 'Hadithi yako inalindwa kupitia mazungumzo ya faragha na usalama wa data.',
            },
            {
                title: 'Msaada wa kibinadamu',
                detail: 'Timu iliyojitolea kukuelekeza, kujibu maswali, na kukutia moyo kwa safari yako.',
            },
        ],
        steps: [
            {
                title: 'Shiriki malengo yako',
                detail: 'Anza kwa kujisajili haraka na utuambie kilicho muhimu kwako.',
            },
            {
                title: 'Kutana kwa makusudi',
                detail: 'Tunakuunganisha na wale wanaolingana na utayari wako wa ndoa.',
            },
            {
                title: 'Songesha mbele kwa ujasiri',
                detail: 'Tuko karibu nawe kwa ukaguzi, mwongozo, na rasilimali njiani.',
            },
        ],
        supportDetails: [
            'Mwongozo wa hatua zinazofuata wakati mazungumzo yanaendelea vizuri au yanahitaji uangalizi.',
            'Profaili zenye usawa kuonyesha ukweli bila kuzidisha.',
            'Njia wazi za kuifikia timu yetu wakati wowote unahitaji msaada.',
        ],
    },
};

export const HOME_LABEL_KEYS = ['signup', 'talkToUs', 'login', 'goToProfile', 'howItWorks', 'reviews', 'faqs'];
